module.exports = __webpack_public_path__ + "img/tu10@2x.ead03501.png";